/********************************************************************
 * @author:      Kaven
 * @email:       kaven@wuwenkai.com
 * @website:     http://blog.kaven.xyz
 * @file:        [Kaven-Basic] /src/libs/number/ToUInt32.ts
 * @create:      2025-06-27 10:43:28.157
 * @modify:      2025-07-11 21:19:12.809
 * @version:     6.0.0
 * @times:       5
 * @lines:       55
 * @copyright:   Copyright © 2018-2025 Kaven. All Rights Reserved.
 * @description: [description]
 * @license:     
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 * 
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 * 
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 ********************************************************************/

/**
 * Converts a given number to an unsigned 32-bit integer.
 *
 * This function performs an addition modulo 2^32, effectively truncating the input
 * to fit within the range of a 32-bit unsigned integer (0 to 4,294,967,295).
 * If the input is negative or exceeds 32 bits, the result wraps around accordingly.
 *
 * @param n - The number to convert.
 * @returns The unsigned 32-bit integer representation of the input.
 * 
 * @since 4.0.0
 * @version 2021-12-14
 */
export function ToUInt32(n: number) {
    // note '>>> 0' for 'addition modulo 2^32'
    // The reason >> works is because it operates only on 32-bit integers, so the value is truncated.

    return n >>> 0;

    // same to:
    // return n & 0xffffffff;
}
